// @ts-strict

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, Subject } from 'rxjs';
import { BaseApiResponse, PageableApiResponse } from '../..';
import { IDeeplinkConfigData } from './deeplink-config.service.types';

@Injectable({
  providedIn: 'root'
})
export class DeeplinkConfigService {
  public newDeeplink: Subject<IDeeplinkConfigData> = new Subject();

  constructor(private http: HttpClient) {}

  public addDeeplinkConfiguration(config_id: number, url: string, program_id: number, domain_id: number): Observable<BaseApiResponse<{ deeplink?: string }>> {
    const deeplinkConfiguration = {
      config_id,
      url,
      domain_id
    };

    return this.http.post<BaseApiResponse<{ deeplink?: string }>>(environment.apiUrl + `/campaigns/${program_id}/deeplinks/store`, deeplinkConfiguration);
  }

  public getDeeplinkConfigurations(programID: number): Observable<PageableApiResponse<{ deeplinks?: IDeeplinkConfigData[] }>> {
    return this.http.get<PageableApiResponse<{ deeplinks?: IDeeplinkConfigData[] }>>(environment.apiUrl + `/campaigns/${programID}/deeplinks/list`);
  }
}
